import BstlArtikel from "@/entities/common/bstl_artikel"
import { Terminart } from "@/entities/common/enums"
import BPArtikelAnzahlRequest from "@/entities/common/pending/bp_artikel_anzahl_request"
import RemoteResult from "@/entities/common/remote_result"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

export default class WarenkorbLogic extends BaseLogic {
  get warenkorb() {
    return this.mainLogic.bestellungPending.artikelliste
  }

  goToShopping() {
    router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
  }

  goToBestaetigen() {
    var terminart = this.mainLogic.bestellungPending.terminart
    if (terminart == Terminart.ABHOLUNG) {
      var direkt = this.mainLogic.bestellungPending.abholung.direktabholung
      if (direkt) {
        router.push({ name: RouteNames.NEU.BESTAETIGEN_ABHOLUNG })
      } else {
        router.push({ name: RouteNames.NEU.KUNDENDATEN })
      }
    } else if (terminart == Terminart.SOFORTBESTELLUNG) {
      router.push({ name: RouteNames.NEU.BESTAETIGEN })
    } else if (terminart == Terminart.RESERVIERUNG) {
      router.push({ name: RouteNames.NEU.KUNDENDATEN })
    }
  }

  increment(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = store.state.user.identifier
    request.artikelId = artikel.id
    request.anzahl = artikel.anzahl + 1

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingArtikelAendern,
      request
    ).then((response) => {
      if (response.data.success) {
        artikel.anzahl += 1
      }
    })
  }

  decrement(artikel: BstlArtikel) {
    if (artikel.anzahl > 1) {
      var request = new BPArtikelAnzahlRequest()
      request.id = store.state.user.identifier
      request.artikelId = artikel.id
      request.anzahl = artikel.anzahl - 1

      Poster.postUser<RemoteResult<any>>(
        RestPaths.bestellungpendingArtikelAendern,
        request
      ).then((response) => {
        if (response.data.success) {
          artikel.anzahl -= 1
        }
      })
    }
  }

  remove(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = store.state.user.identifier
    request.artikelId = artikel.id
    request.loeschen = true

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingArtikelAendern,
      request
    ).then((response) => {
      if (response.data.success) {
        var index = this.mainLogic.bestellungPending.artikelliste.findIndex(
          (x) => {
            x.id === artikel.id
          }
        )
        if (index > -1) {
          this.mainLogic.bestellungPending.artikelliste.splice(index, 1)
        }

        this.warenkorb.splice(
          this.warenkorb.findIndex((x) => {
            return x.id === artikel.id
          }),
          1
        )
        if (this.warenkorb.length == 0) {
          router.go(-1)
        }
      }
    })
  }
}
